import React, { useEffect, useState } from "react";
import SidebarFarmaceutico from "../../components/sidebar_farmaceutico/Sidebar_Farmaceutico";
import Axios from "axios";
import { useHistory } from "react-router-dom";
import { formatDate } from "../../utils/date";

const TelecAbertaFarm = (props) => {
  const [cpf, setCPF] = useState("");
  let history = useHistory();

  const assumir = (id) => {
    Axios.defaults.withCredentials = false;

    Axios.post(`${process.env.REACT_APP_API_BASE_URL}/assumirTelec`, {
      id: id,
      cpf: cpf,
    }).then((response) => {
      if (response.data.aviso) {
        alert(response.data.aviso);
      } else {
        alert("Você assumiu a teleconsultoria ID: " + id);
        carregaDados();
      }
    });
  };

  const abrir = (id) => {
    history.push({
      pathname: "/farmaceutico/detalhes",
      state: { detail: id },
    });
  };

  Axios.defaults.withCredentials = true;

  const [lista, setLista] = useState([]);

  useEffect(() => {
    carregaDados();
    Axios.get(`${process.env.REACT_APP_API_BASE_URL}/login`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then((response) => {
      if (response.data.loggedIn === true) {
        setCPF(response.data.user[0].cpf);
      }
    });
  }, []);

  const carregaDados = () => {
    Axios.defaults.withCredentials = false;

    Axios.get(`${process.env.REACT_APP_API_BASE_URL}/telecAbertas`).then(
      (response) => {
        if (response.data.message) {
          alert(response.data.message);
        }
        console.log(response);
        setLista(response.data);
      }
    );
  };

  return (
    <>
      <SidebarFarmaceutico>
        <div class="main__container">
          <table class="content-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>SOLICITANTE</th>
                <th>DATA</th>
                <th>ÁREA INTERESSE</th>
                <th>STATUS</th>
                <th>AÇÃO</th>
              </tr>
            </thead>
            <tbody align="justify">
              {lista.map((item) => (
                <tr>
                  <th>{item.id}</th>
                  <th>{item.nome}</th>
                  <th>{formatDate(item.data_hora)}</th>
                  <th>{item.area_interesse}</th>
                  <th>{item.status}</th>
                  <th>
                    <a
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: "column",
                        alignContent: "middle",
                      }}
                      id={item.id}
                      onClick={(e) => abrir(e.target.id)}
                    >
                      Abrir
                    </a>
                    <a
                      id={item.id}
                      style={{ cursor: "pointer" }}
                      onClick={(e) => assumir(e.target.id)}
                    >
                      Assumir
                    </a>
                  </th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SidebarFarmaceutico>
    </>
  );
};
export default TelecAbertaFarm;
